<div class="quick-apply-container">
  <app-talent-happy-path-header [headerText]="$safeNavigationMigration(posting?.jobTitle)" [headerOverlineText]="'talent-happy-path.quick-apply.header-overline-text' | translate"></app-talent-happy-path-header>
  <div class="container-body">
    <router-outlet *ngIf="isQuickApplyLoaded"></router-outlet>
  </div>
  <app-talent-happy-path-footer [postingInfo]="posting" class="quick-apply-footer"></app-talent-happy-path-footer>
</div>
